import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RegularRate, callBackFactor, callBackRate } from 'app/models/Placement/PlacementMods';
import { CallBackFactor } from '../../PayRate/PayFactor/CallbackFactor';
import { getCalculatedAmount } from './BillOvertime';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from './BillOrientation';

export const BillCallBack = ({ classes, isModEdit }: { classes: any; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const regularRateValue = useWatch<string>({ name: RegularRate });

  return (
    <Grid item className={classes.flex}>
      <Controller
        name={callBackRate}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={getValues(callBackRate)}
            className={classes.billFactorTextfields}
            InputLabelProps={{
              shrink: getValues(callBackRate),
            }}
            variant="filled"
            label={`${t(`placement.placementMods.${callBackRate}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, callBackRate) : getInvalidAmount()}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                setValue(callBackRate, e.target.value);
                onChange(e.target.value);
                setValue(callBackFactor, '');
              }
            }}
            InputProps={{
              readOnly: false,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>
                  {getValues(callBackRate) && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}
                </>
              ),
              sx: { fontSize: '14px' },
            }}
            {...rest}
          />
        )}
      />
      <div className={classes.middleText}>{'OR'}</div>

      <CallBackFactor classes={classes} currentMod={'BillRate'} isModEdit={isModEdit} />
    </Grid>
  );
};
